import { render, staticRenderFns } from "./DeviceProperties.vue?vue&type=template&id=3220aada&scoped=true"
import script from "./DeviceProperties.vue?vue&type=script&lang=js"
export * from "./DeviceProperties.vue?vue&type=script&lang=js"
import style0 from "./DeviceProperties.vue?vue&type=style&index=0&id=3220aada&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3220aada",
  null
  
)

export default component.exports